import { useEffect, useState, useRef } from "react";
import { getLegalTextBySponsor } from '../../functions/functions.js';
import { getCarrousel, getFilters } from "../../services/getCarrouselSponsored.js";
import { getAll } from "../../services/getToday.js";
import WidgetContainer from "../reusablesComponents/containerWidget.js";
import Carrousel from "../reusablesComponents/carrousel.js";
import Legal from "../legal/legal.js";
import NoEvents from '../noEvents/noEvents.js';
import Loading from '../loading/loading.js';
import CarrouselSponsoredLeft from "./carrouselSponsoredLeft/carrouselSponsoredLeft.js";
import "./carrouselSponsored.sass";
import { API_CORE_URL_RELATIVE } from "../../constantes/constantes.js";

/**
 * Renderiza el carrousel patrocinado con el menu de ligas
 */
export default function CarrouselSponsored({ patrocinador: sponsor, flagMomios, version }) {
  const [data, setData] = useState([]);
  const [dataFilters, setDataFilters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [carrouselLoading, setCarrouselLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [usingGetAll, setUsingGetAll] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [indexJson, setIndexJson] = useState(0);
  const [dataLoaded, setDataLoaded] = useState(false); // Track cuando data fue cargada
  const fetchingFilters = useRef(false);
  const activeMomios = flagMomios === true || flagMomios === "true";

  const legalText = getLegalTextBySponsor(sponsor);

  // Obtener filtros y datos iniciales
  useEffect(() => {
    if (fetchingFilters.current) return;

    const fetchInitialData = async () => {
      fetchingFilters.current = true;
      try {
        // Obtener filtros primero
        const filtersResult = await getFilters({ version });
        const leagues = filtersResult.statusCode === 200 ? filtersResult.data.leagues : [];
        setDataFilters(leagues);

        // Intentar getAll para datos iniciales
        // const allResult = await getAll();

        // if (allResult.statusCode === 200) {
        //   setData(Array.isArray(allResult.data) ? allResult.data : []);
        //   setSelectedValue(leagues[0] || { name: 'Todos' });
        //   setUsingGetAll(true);
        // } else 
        if (leagues.length > 0) {
          setSelectedValue(leagues[0]);
        }
      } catch (error) {
        console.error("Error al obtener datos iniciales:", error);
      } finally {
        fetchingFilters.current = false;
        setLoading(false);
      }
    };

    fetchInitialData();
  }, []);

  // Obtener datos del carrusel cuando cambia el filtro seleccionado
  useEffect(() => {
    if (!selectedValue?.url || usingGetAll) return;

    const fetchCarrouselData = async () => {
      setCarrouselLoading(true);
      setDataLoaded(false); // Reset cuando inicia carga
      try {
        const response = await getCarrousel({ endpoint: API_CORE_URL_RELATIVE + selectedValue.url, version });
        const responseData = Array.isArray(response?.data) ? response.data : [];
        setData(responseData);
      } catch (error) {
        console.error("Error al obtener datos del carrusel:", error);
        setData([]);
      } finally {
        setCarrouselLoading(false);
        setDataLoaded(true); // Data está listo, aunque esté vacío
      }
    };

    fetchCarrouselData();
  }, [selectedValue]);

  /**
  * Actualiza el filtro seleccionado al hacer clic en una liga
  */
  const selectedJson = async (selected) => {
    setUsingGetAll(false);
    setSelectedValue(selected);
    // No setear carrouselLoading aquí, lo maneja el useEffect
  }

  return (
    <WidgetContainer loading={loading} heightLoading={115} className="container__carrousel-sponsored" id="container__carrousel-sponsored">
      <div className="carrousel-sponsored__left-right">
        <CarrouselSponsoredLeft dataFilters={dataFilters} selectedJson={selectedJson} selectedValue={selectedValue} setScrollPosition={setScrollPosition} scrollPosition={scrollPosition} setIndexJson={setIndexJson} />
        {carrouselLoading ? (
          <Loading type={120} />
        ) : dataLoaded && data?.length === 0 ? (
          <NoEvents />
        ) : (
          <Carrousel
            data={data}
            cardWidth={130}
            activeMomios={flagMomios}
            loading={false}
            patrocinador={sponsor}
            classCarrousel="carrousel-card-sponsored"
            classPrefix="carrousel-sponsored-right"
            indexJson={indexJson}
          />
        )}
      </div>

      {/* mostrar leyenda de copy legal */}
      {activeMomios && !loading && legalText.trim().length > 0 && (
        <Legal patrocinador={sponsor} />
      )}
    </WidgetContainer>
  )
}